<template lang="pug">
.node(:style="style", :class="{selected: selectedQuestion && selectedQuestion.id === question.id}", @click="select", @mouseup="$emit('finishConnect')")
	.id {{ question.id }}
	.question {{ questionText }}
	.options
		template(v-if="question.answer.type === 'chooseOne'")
			.option.option-any(:class="{disabled: hasNextOptions}")
				.text any
				bunt-icon-button(v-if="!question.next && !hasNextOptions", @click="addNext", @mouseleave.native="startConnect($event, question)") add
			.option(v-for="option in question.answer.options", :class="{disabled: question.next}")
				.text {{ option.text }}
				bunt-icon-button(v-if="!question.next && !option.next", @click="addNextToOption(option)", @mouseleave.native="startConnect($event, option)") add
		.option.option-next(v-else)
			.text next
			bunt-icon-button(v-if="!question.next", @click="addNext", @mousedown.native="$emit('startConnect', question)") add
</template>
<script>
import { mapState } from 'vuex'
export default {
	components: {},
	props: {
		question: Object,
		position: Object
	},
	data () {
		return {
		}
	},
	computed: {
		...mapState(['selectedQuestion']),
		style () {
			return {
				top: this.position?.y + 'px',
				left: `calc(50% + ${this.position?.x}px - 250px)`
			}
		},
		questionText () {
			if (this.question.question.function) {
				try {
					return new Function('answers', this.question.question.function)({})
				} catch(e) {
					return e.message
				}
			}
			return this.question.question
		},
		hasNextOptions () {
			return this.question.answer.options?.some(option => option.next)
		}
	},
	created () {},
	mounted () {
		this.$nextTick(() => {
		})
	},
	methods: {
		select () {
			this.$store.commit('SELECT_QUESTION', this.question)
		},
		addNext () {
			this.$store.dispatch('createQuestionAndConnect', this.question)
		},
		addNextToOption (option) {
			this.$store.dispatch('createQuestionAndConnect', option)
		},
		startConnect (event, connectFrom) {
			if (event.buttons !== 1) return
			this.$emit('startConnect', connectFrom)
		}
	}
}
</script>
<style lang="stylus">
@import '~settings'
.node
	position: absolute
	height: 150px
	width: 500px
	border: 2px solid $clr-primary
	border-radius: 2px
	display: flex
	flex-direction: column
	padding: 8px
	box-sizing: border-box
	&.selected
		outline: 6px solid $clr-primary
	.id
		color: $clr-secondary-text-light
	.question
		font-size: 18px
		padding: 4px 0

	.options
		position: absolute
		bottom: 0
		left: 0
		max-height: 70px
		width: 100%
		display: flex
		border-top: 1px solid $clr-primary
		.option
			flex: 1 1 0
			padding: 4px 4px 4px 8px
			word-break: break-all
			position: relative
			&:not(:last-child)
				border-right: 1px solid $clr-primary
			&.disabled
				background-color: $clr-grey-100
			.text
				max-height: 100%
				overflow: hidden
			.bunt-icon-button
				background-color: $clr-primary
				color: $clr-white
				border-radius: 0 0 50% 50%
				position: absolute
				bottom: -36px
				left: calc(50% - 18px)
				&:hover
					background-color: darken($clr-primary, 25%)
</style>
